import classNames from 'classnames';
import { FC } from 'react';

import * as Styles from './styles.module.less';

export const InfoIcon: FC<{ className?: string }> = ({ className = '' }) => (
    <span className={classNames(Styles.icon, className)} />
);
